<template>
  <div class="sales-planning">
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <legend>
          <strong>{{ $t('configuration') }}</strong>
        </legend>
        <SolarPlantItems :project="project" />
      </b-col>
      <b-col lg="5" md="5" sm="12">
        <div v-if="project.onHoldState">
          <legend>
            <strong>{{ $t('PLANNING_QUERIES') }}</strong>
          </legend>

          <div class="form-grid-container-left">
            <div class="label">{{ $t('PLANNING_QUERIES') }}</div>
            <div>
              <multiselect
                :placeholder="$t('PLANNING_QUERIES')"
                v-model="project.onHoldState.onHold"
                :options="yesNo()"
                :allow-empty="false"
                :show-labels="false"
                deselectLabel
                @select="onChangeProjectOnHoldState"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <b-badge :variant="yesNoStateReversedColor(option)">
                    {{ $t(option) }}
                  </b-badge>
                </template>
                <template slot="option" slot-scope="{ option }">
                  <b-badge :variant="yesNoStateReversedColor(option)">
                    {{ $t(option) }}
                  </b-badge>
                </template>
              </multiselect>
            </div>

            <template
              v-if="
                project.onHoldState.onHold === 'YES' ||
                  project.onHoldState.description != '' ||
                  project.onHoldState.comment != ''
              "
            >
              <div class="label">{{ $t('reason') }}</div>
              <div>
                {{ $t(project.onHoldState.reason) }}
              </div>

              <div class="label">{{ $t('description') }}</div>
              <div>
                <Textarea v-model="project.onHoldState.description" rows="3" cols="80" />
              </div>

              <div class="label">{{ $t('comment') }}</div>
              <div>
                <Textarea v-model="project.onHoldState.comment" rows="3" cols="80" />
              </div>
            </template>
          </div>
        </div>

        <legend>
          <strong>{{ $t('notes') }}</strong>
        </legend>
        <b-form-group horizontal breakpoint="md">
          <ckeditor
            :editor="editor"
            v-model="project.sales.notesPlanning"
            :config="editorConfig"
          ></ckeditor>
        </b-form-group>
      </b-col>
    </b-row>

    <Dialog
      header="Begründung erforderlich"
      :visible.sync="displayStateChangeConfirmation"
      :contentStyle="{ overflow: 'visible' }"
      :modal="true"
    >
      <div v-if="project.onHoldState">
        <div class="flex-row">
          <div>{{ $t('reason') }}</div>
          <div>
            <Dropdown
              v-model="project.onHoldState.reason"
              :options="getEnumValues('OnHoldReason')"
              :placeholder="$t('select')"
            >
              <template #option="slotProps">
                <b-badge>
                  {{ $t(slotProps.option) }}
                </b-badge>
              </template>
              <template #value="slotProps">
                <b-badge>
                  {{ $t(slotProps.value) }}
                </b-badge>
              </template>
            </Dropdown>
          </div>
        </div>

        <div class="flex-row">
          <div>{{ $t('description') }}</div>
          <div>
            <Textarea v-model="project.onHoldState.description" rows="3" cols="40" />
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          class="btn btn-narrow btn-default ml-2 mb-2"
          @click="onCancelProjectOnHoldStateChangeReason"
        >
          {{ $t('cancel') }}
        </Button>
        <Button
          class="btn btn-narrow btn-inverse ml-2 mb-2"
          @click="onSaveProjectOnHoldStateChangeReason"
          :disabled="onHoldStateOkButtonDisabled"
        >
          {{ $t('ok') }}
        </Button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import SolarPlantItems from '@/components/SolarPlant/SolarPlantItems.vue';

import { yesNo } from '@/helpers/enums';
import { yesNoStateReversedColor } from '@/helpers/colors';
import Textarea from 'primevue/textarea';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';

export default {
  components: {
    Multiselect,
    Textarea,
    Dialog,
    Dropdown,
    ckeditor: CKEditor.component,
    SolarPlantItems,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      displayStateChangeConfirmation: false,
      editor: InlineEditor,
      editorConfig: {
        allowedContent: false,
        forcePasteAsPlainText: true,
      },
    };
  },
  computed: {
    ...mapGetters(['getEnumValues']),
    onHoldStateOkButtonDisabled() {
      return this.project.onHoldState && this.project.onHoldState.description !== '' ? false : true;
    },
    optionsYesNo() {
      return yesNo();
    },
  },
  methods: {
    ...mapActions(['fetchEnumValues']),
    yesNo,
    yesNoStateReversedColor,
    /**
     * if project.onHoldState is changed to yes a reason has to be given
     * @param {*} newState
     */ onChangeProjectOnHoldState(newState) {
      console.log('onChangeProjectOnHoldState()', newState);

      if (newState === 'YES') {
        this.displayStateChangeConfirmation = true;
      }
    },
    onCancelProjectOnHoldStateChangeReason() {
      // console.log(
      //   'onCancelProjectStateChangeReason()',
      //   this.project.projectState,
      //   this.projectStateBackup
      // );
      this.project.onHoldState.onHold = 'NO';
      this.displayStateChangeConfirmation = false;
    },
    onSaveProjectOnHoldStateChangeReason() {
      // console.log('onSaveProjectStateChangeReason()', this.project.onHoldState);
      this.displayStateChangeConfirmation = false;
    },
    async setup() {
      await this.fetchEnumValues('OnHoldReason');

      /** init onHoldState */
      if (!this.project.onHoldState) {
        this.project.onHoldState = {
          onHold: 'NO',
          reason: 'MISC',
          description: '',
          comment: '',
        };
      }
    },
  },
  async mounted() {
    await this.setup();
  },
};
</script>
<style scoped lang="scss">
.form-grid-container-left {
  display: grid;
  grid-template-columns: 1fr 2fr;
  column-gap: 1em;
  row-gap: 1em;
}
.form-grid-container-left .label {
  text-align: right;
}
</style>
